import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonusOffer() {
  return <section className="bg-brand-dark pb-4" data-id="element-3">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-4">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-brand-green/10 border border-brand-green/30 rounded-2xl p-8 md:p-10 text-center" data-id="element-5">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-brand-green/20 text-brand-green mb-5" data-id="element-6">
            <Gift size={24} data-id="element-7" />
          </div>
          <p className="font-serif text-2xl md:text-3xl text-white leading-snug" data-id="element-8">
            Comprando <span className="text-brand-green font-bold" data-id="element-9">HOY</span>,
            llevate también el sistema{' '}
            <span className="text-brand-green font-bold" data-id="element-10">
              "Triatlón en 6HS"
            </span>
          </p>
          <p className="text-white/70 text-lg mt-4 max-w-2xl mx-auto" data-id="element-11">
            Entendé cómo entrenar durante las semanas difíciles, sin perder
            rendimiento.
          </p>
        </motion.div>
      </div>
    </section>;
}